import { render, staticRenderFns } from "./KeyProjects.vue?vue&type=template&id=41c3b305"
import script from "./KeyProjects.vue?vue&type=script&lang=js"
export * from "./KeyProjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports